import { render } from "./UnNFTsNavigation.vue?vue&type=template&id=0ff3d512&scoped=true"
import script from "./UnNFTsNavigation.vue?vue&type=script&lang=js"
export * from "./UnNFTsNavigation.vue?vue&type=script&lang=js"

import "./UnNFTsNavigation.vue?vue&type=style&index=0&id=0ff3d512&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff3d512"]])

export default __exports__